var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMosaicTwowayStart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.069,
    height: 39.864,
    viewBox: "0 0 59.069 39.864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3330",
    "data-name": "Group 3330",
    transform: "translate(-187.11 -17.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M246.179,42.451,231.008,27.033v8.379H211.376v1l-.01-1-11.085.118v7.8L189.932,33.055l10.349-10.518v5.5h26.6v-2h-24.6V17.652L187.11,33.071l15.171,15.065V37.508l9.106-.1h21.621v-5.5l10.349,10.517L233.008,52.711V44.9H205.757v2h25.251V57.516Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M212.206,41.318a5.187,5.187,0,0,0,7.339,0,1,1,0,0,0-1.414-1.414,3.263,3.263,0,0,1-4.51,0,1,1,0,1,0-1.415,1.414",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M209.821,45a8.557,8.557,0,0,0,12.107,0,1,1,0,0,0-1.414-1.414,6.558,6.558,0,0,1-9.279,0A1,1,0,1,0,209.821,45",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M214.37,34.63A2.385,2.385,0,0,0,217.744,38a2.391,2.391,0,0,0,0-3.374,2.444,2.444,0,0,0-3.372,0m1.96,1.958a.387.387,0,0,1-.546,0,.381.381,0,0,1-.113-.271.386.386,0,0,1,.114-.274.378.378,0,0,1,.271-.112.385.385,0,0,1,.274.657",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M222.332,47.862a9.141,9.141,0,0,1-12.913,0,1,1,0,0,0-1.414,1.414,11.145,11.145,0,0,0,15.741,0,1,1,0,0,0-1.414-1.414",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M219.725,32.505a1,1,0,0,0,0-1.415,5.189,5.189,0,0,0-7.339,0,1,1,0,1,0,1.414,1.415,3.263,3.263,0,0,1,4.51,0,1,1,0,0,0,1.415,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M222.109,27.411a8.558,8.558,0,0,0-12.106,0,1,1,0,1,0,1.414,1.414,6.559,6.559,0,0,1,9.278,0,1,1,0,0,0,1.414-1.414",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M208.892,24.841a1,1,0,0,0,.707-.293,9.129,9.129,0,0,1,12.913,0,1,1,0,0,0,1.415-1.414,11.13,11.13,0,0,0-15.742,0,1,1,0,0,0,.707,1.707",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosaicTwowayStart);
export default __webpack_public_path__ + "static/media/MosaicTwowayStart.b09cb35d800711775328f2386e63053b.svg";
export { ForwardRef as ReactComponent };